import axios from "axios";

const baseURL = `${process.env.EMPLEO_SERVICES_API_URL}`;
const url = `${process.env.AGW_EMPLEO_SERVICES_API_URL}`;
const apikeyServices = process.env.AGW_EMPLEO_SERVICES_API_KEY;
const newTokenizer = process.env.URL_TOKENIZER;

const getToken = async () => {
    const data = await axios.post(
        `${newTokenizer}`,
        {'action': 'getJWT'},
        {
            headers: {
                Apikey: process.env.URL_TOKENIZER_APIKEY,
                Origin: process.env.URL_TOKENIZER_ORIGIN,
                "Content-Type": "application/json",
            },
        }
    );
    return data;
};

const getSchedulingMentoria = async (document_number: string, document_type: string ) => {
    const token = await getToken();
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    return axios.get(`${url}comfama/common/api/v1/mentoria/scheduling/${document_number}/${document_type}`, { headers });
};

export default getSchedulingMentoria;